export const swiperClasses = {
  root: 'swiper',
  wrapper: 'swiper-wrapper',
  slide: 'swiper-slide',
  slidePartial: 'swiper-slide-partial',
  slideActive: 'swiper-slide-active',
  slideNext: 'swiper-slide-next',
  slidePrev: ' swiper-slide-prev',
  buttonDisabled: 'swiper-button-disabled',
  swiperButtonNext: 'swiper-button-next',
  swiperButtonPrev: 'swiper-button-prev',
  swiperTopButton: 'swiper-top-button',
  swiperTopButtonNext: 'swiper-top-button-next',
  swiperTopButtonPrev: 'swiper-top-button-prev',
  swiperImage: 'swiper-image',
  swiperImageSliderImage: 'swiper-image-slider-image',
  swiperLazyPreloader: 'swiper-lazy-preloader',
  headerClasses: {
    withHeader: 'swiper-header--with-header',
    withAdditionalContent: 'swiper-header--with-additional-content',
  },
}
